import { notif } from "../RTDNotifV2";
import { GenericDataSet } from "./GenericDataSet";
export default class DataSetFactory {
    constructor() {
        return (async () => {
            await notif.init();
            return this;
        })();
    }
    createDataSet(type) {
        return new GenericDataSet(type);
    }
}
